import { COMPLETION_CODE_MESSAGES, ERROR_CODE_DEFINITIONS } from './error-code-definitions';
import type { CompletionCode, ErrorCode } from './error-code-definitions';

export { COMPLETION_CODE_MESSAGES, ERROR_CODE_DEFINITIONS };
export type { CompletionCode, ErrorCode };

/** 辞書に無いコードのときの既定の文言（仕様書 10 章 コード対応表の補足：MSG-E-009） */
export const UNKNOWN_ERROR_MESSAGE = 'エラーが発生しました。';

/** エラー応答の details の 1 項目（02 2.4） */
export interface ErrorDetailItem {
  field: string;
  code: string;
  message: string;
}

/** エラー応答の形（02 2.4・要件書 9.2） */
export interface ErrorResponseBody {
  error: {
    code: string;
    message: string;
    details: ErrorDetailItem[] | Record<string, unknown>;
    trace_id: string;
  };
}

export function isErrorCode(code: string): code is ErrorCode {
  return Object.prototype.hasOwnProperty.call(ERROR_CODE_DEFINITIONS, code);
}

/** コード → HTTP ステータス（辞書に無いコードは 500） */
export function httpStatusOf(code: string): number {
  return isErrorCode(code) ? ERROR_CODE_DEFINITIONS[code].http_status : 500;
}

/** コード → 文言（辞書に無いコードは MSG-E-009） */
export function errorMessageOf(code: string): string {
  return isErrorCode(code) ? ERROR_CODE_DEFINITIONS[code].message : UNKNOWN_ERROR_MESSAGE;
}
